// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-entries-list {
  overflow-y: auto;
}
.dl-entries-list__item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 4px;
}
.dl-entries-list__item-icon {
  flex-shrink: 0;
}
.dl-entries-list__action-place {
  flex: 1 0;
  margin-left: 4px;
  display: flex;
  justify-content: flex-end;
}
.dl-entries-list__name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 0;
  margin-left: 8px;
}
.dl-entries-list__login {
  overflow: hidden;
  flex: 1 0;
  margin: 0 8px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntriesList/EntriesList.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EACI,gBAAA;AADJ;AAGI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AADR;AAII;EACI,cAAA;AAFR;AAKI;EACI,SAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;AAHR;AAMI;ECnBA,mBAAA;EACA,gBAAA;EACA,uBAH4B;EDsBxB,SAAA;EACA,gBAAA;AAFR;AAKI;EACI,gBAAA;EACA,SAAA;EACA,aAAA;AAHR","sourcesContent":[".dl-entries-list {\n  overflow-y: auto;\n}\n.dl-entries-list__item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 0 4px;\n}\n.dl-entries-list__item-icon {\n  flex-shrink: 0;\n}\n.dl-entries-list__action-place {\n  flex: 1 0;\n  margin-left: 4px;\n  display: flex;\n  justify-content: flex-end;\n}\n.dl-entries-list__name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1 0;\n  margin-left: 8px;\n}\n.dl-entries-list__login {\n  overflow: hidden;\n  flex: 1 0;\n  margin: 0 8px;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
